import { use18n } from 'src/utils/v2_helper/common'

export function useErrMsg() {
  const { $t } = use18n();
  const e = {
    1002: $t('login.errorMsg3'),
    1016: $t('login.errorMsg6')
  }
  return { e }
}

